import { Cookie } from '@nuxt-common/util/app/utils/cookie';
import $http from '@nuxt-common/util/app/utils/http';

export function redirect(url) {
  window.location.href = url;
}

export function relativeRedirect(relativePath) {
  redirect(relativePath);
}

export default function sessionTimeOutHandler() {
  $http.interceptors.response.use(
    (response) => response,
    (error) => {
      const { status, data } = error?.response || {};
      if (status === 401 && data) {
        const domain = Cookie.getHostName();
        Cookie.remove('SignedIn', null, {
          domain,
        });
        Cookie.set('SE', 1, 'SNSGCs', {
          domain,
        });
        Cookie.set('FORWARDPAGE_KEY', window.location, null, {
          domain,
        });
        relativeRedirect('/account/signin-loyalty');
      }
      return Promise.reject(error);
    },
  );
}
